export default __webpack_public_path__ + "static/media/youtube.81d56b71.svg";